import { useSmartTableQuery } from '../../manager/components/context';
import { useSmartTableWithQueryParams } from '@weezevent/smart-table';
import { Columns } from './constants';
import { useTranslation } from 'react-i18next';

export const useColumns = ({ organization, event }) => {
    const [columnsOrder, setColumnsOrder] = useSmartTableQuery('attendees-columns');
    const { t } = useTranslation();

    const columns = [
        {
            key: Columns.SOLD_DATE,
            label: t('ticket.manager.tableHeader.soldDate')
        },
        {
            key: Columns.ATTENDEE,
            label: t('ticket.manager.tableHeader.attendee')
        },
        {
            key: Columns.ATTENDEE_ID,
            label: t('ticket.manager.tableHeader.attendee_id')
        },
        {
            key: Columns.MEMBERSHIP_CODE,
            label: t('ticket.manager.tableHeader.membership_code')
        },
        {
            key: Columns.COMPANY,
            label: t('ticket.manager.tableHeader.company'),
            isHidden: !organization?.feature_flags.includes('EO_COMPANY_GDP')
        },
        {
            key: Columns.BARCODE,
            label: t('ticket.manager.tableHeader.barcode')
        },
        {
            key: Columns.RATE,
            label: t('ticket.manager.tableHeader.rate')
        },
        {
            key: Columns.PAID_PRICE,
            label: t('ticket.manager.tableHeader.paid_price')
        },
        {
            key: Columns.SEAT,
            label: t('ticket.manager.tableHeader.seat'),
            isHidden: !event.is_seated
        },
        {
            key: Columns.SESSION,
            label: t('ticket.manager.tableHeader.session'),
            isHidden: !event.use_sessions
        },
        {
            key: Columns.SCANNED,
            label: t('ticket.manager.tableHeader.scanned')
        },
        {
            key: Columns.STATUS,
            label: t('ticket.manager.tableHeader.status')
        },
        {
            key: Columns.MODERATION_STATUS,
            label: t('ticket.manager.tableHeader.moderationStatus'),
            isHidden: !event.is_moderation_enabled
        },
        {
            key: Columns.MAILS,
            label: t('ticket.manager.tableHeader.mails'),
            isHidden: !event.is_moderation_enabled
        },
        {
            key: Columns.PARTNER,
            label: t('ticket.manager.tableHeader.partner')
        },
        {
            key: Columns.ACTIONS,
            label: t('ticket.manager.tableHeader.actions')
        }
    ].filter(({ isHidden }) => !isHidden);

    return useSmartTableWithQueryParams({
        columns,
        defaultConfig: columns.map(column => ({
            key: column.key,
            hidden: [Columns.ATTENDEE_ID, Columns.MEMBERSHIP_CODE, Columns.PAID_PRICE, Columns.PARTNER].includes(column.key)
        })),
        queryParamState: {
            value: columnsOrder,
            onChange: setColumnsOrder
        },
        configRestrictions: {
            alwaysDisplayed: [Columns.ATTENDEE, Columns.SOLD_DATE, Columns.BARCODE]
        }
    });
};
